import PrescriberPage from './PrescriberPage'

export default PrescriberPage
